import { memo } from 'react'

// NOTIF 2 (pílula fina/legada "enviou e ganhou") REMOVIDA PERMANENTEMENTE a pedido.
// A notificação de presente EM NÍVEIS (toast-send-global) já cobre. Esta webview
// é webview/store SEPARADO da de níveis, então isto NÃO a afeta.
export const ToastEarnedGlobal = memo(() => {
  return null
})
